import React, { useState } from "react";
import styles from "./Tooltip.module.scss";
import QuestionMarkIcon from "public/icons/question-mark.svg";
import classNames from "classnames";

type Props = {
  tooltipText: string;
};

const Tooltip = (props: Props) => {
  const [visible, setVisible] = useState<boolean>(false);

  return (
    <>
      <QuestionMarkIcon
        onMouseOver={() => setVisible(true)}
        onMouseOut={() => setVisible(false)}
      />
      <div className={styles.tooltip}>
        <p
          className={classNames(
            styles.tooltipText,
            visible ? styles.visible : styles.fadeout
          )}
        >
          {props.tooltipText}
        </p>
      </div>
    </>
  );
};

export default Tooltip;
